

















import { Component, Vue, Watch, Provide } from "vue-property-decorator";
import { timeFormat } from "@/utils";
const personComponent = () =>
  import("@/views/PerformanceManagement/component/person.vue");
const groupComponent = () =>
  import("@/views/PerformanceManagement/component/group.vue");
@Component({
  name: "PerformanceDashboard",
  components: {
    personComponent,
    groupComponent,
  },
})
export default class PerformanceDashboard extends Vue {
  @Provide() private token: any = "";
  @Provide() private userid: any = "";
  @Provide() private MorkResultData: any = [
    {
      Id: 1111,
      ExtNumber: 1111,
      Utime: 1111,
      Supplier: 1111,
    },
  ];
  @Provide() private isMorked: boolean = false; // lee 模拟数据
  @Provide() private resultPersonalData: any = [];
  @Provide() private resultGroupData: any = [];
  @Provide() private chartPerson: any = [];
  @Provide() private chartData: any = [];
  @Provide() private chartGroup: any = [];
  @Provide() private roleType: number = 0; // 1 组  2 个人
  @Provide() private exectype: any = 0; // 1 组  2 个人
  private dataCircle: any = [
    {
      name: "Apples",
      value: 70,
    },
    {
      name: "Strawberries",
      value: 68,
    },
    {
      name: "Bananas",
      value: 48,
    },
    {
      name: "Oranges",
      value: 40,
    },
    {
      name: "Pears",
      value: 32,
    },
    {
      name: "Pineapples",
      value: 27,
    },
    {
      name: "Grapes",
      value: 18,
    },
  ];
  private optionsCircle: any = {
    title: [
      {
        text: "Pie label alignTo",
      },
      {
        subtext: 'alignTo: "none" (default)',
        left: "16.67%",
        top: "75%",
        textAlign: "center",
      },
      {
        subtext: 'alignTo: "labelLine"',
        left: "50%",
        top: "75%",
        textAlign: "center",
      },
      {
        subtext: 'alignTo: "edge"',
        left: "83.33%",
        top: "75%",
        textAlign: "center",
      },
    ],
    series: [
      {
        type: "pie",
        radius: "25%",
        center: ["50%", "50%"],
        data: this.dataCircle,
        animation: false,
        label: {
          position: "outer",
          alignTo: "none",
          bleedMargin: 5,
        },
        left: 0,
        right: "66.6667%",
        top: 0,
        bottom: 0,
      },
      {
        type: "pie",
        radius: "25%",
        center: ["50%", "50%"],
        data: this.dataCircle,
        animation: false,
        label: {
          position: "outer",
          alignTo: "labelLine",
          bleedMargin: 5,
        },
        left: "33.3333%",
        right: "33.3333%",
        top: 0,
        bottom: 0,
      },
      {
        type: "pie",
        radius: "25%",
        center: ["50%", "50%"],
        data: this.dataCircle,
        animation: false,
        label: {
          position: "outer",
          alignTo: "edge",
          margin: 20,
        },
        left: "66.6667%",
        right: 0,
        top: 0,
        bottom: 0,
      },
    ],
  };
  private mounted() {
    this.token = localStorage.getItem("token");
    this.exectype = sessionStorage.getItem("exectype");
    this.userid = this.getUid()
      ? this.getUid()
      : localStorage.getItem("userid"); // 如果在url上匹配到uid即为组长查看组员的dashaboard
    if (this.exectype == 1 || this.exectype == 2) this.getExtenList(); // 获取列表数据
  }
  private getUid() {
    if (this.$route.query && this.$route.query.uid) {
      return this.$route.query.uid;
    }
    return "";
  }
  private async getExtenList() {
    let _arg = {
      trackId: "",
      clientId: "",
      token: this.token,
      userid: Number(this.userid),
    };
    const { getUrgeDashboardApi }: any = await import("@/request/dashboard");
    let res = await getUrgeDashboardApi(_arg);
    if (res) {
      this.roleType = res.roletype;
    }
  }
}
